import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmBoxEvokeService, DialogLayoutDisplay, ToastUserViewTypeEnum } from '@costlydeveloper/ngx-awesome-popup';
import { DsAuthJWTToken, DsAuthService } from '@direction/auth';
import { ResourceService } from '@direction/translate';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { MockData } from '../../mock/data.mock';
import { UnitCode } from '../../models/UnitCode';
import { GlobalUser } from '../../models/global.user.model';
import { HelpersService } from '../../services/helpers.service';
import { ModalService } from '../../services/modal.service';
import { TurnstileService } from '../../services/turnstile.service';
import { UserService } from '../../services/user.service';
import { FavoriteMenu } from './../../models/favoriteMenu.model';
import { MenuService } from './../../services/menu.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  version: string = environment.appVersion;
  loggedUser: GlobalUser = new GlobalUser();
  userName: string[] = [''];
  menuFavorite: FavoriteMenu[] = [];
  tempSub: any;
  unitCodes: string[];
  unitCodeSelected: string = '';

  subUnitcodeSelected$: BehaviorSubject<string> = new BehaviorSubject<string>(this.unitCodeSelected);

  constructor(
    private userService: UserService,
    private authService: DsAuthService,
    private helpersService: HelpersService,
    private menuService: MenuService,
    private router: Router,
    public resourceService: ResourceService,
    private mockData: MockData,
    private modalService: ModalService,
    private turnstileService: TurnstileService,
    private confirmBoxEvokeService: ConfirmBoxEvokeService
  ) {}

  ngOnInit(): void {
    this.authService.onTokenChange().subscribe((token: DsAuthJWTToken) => {
      if (token.isValid()) {
        this.userService.getMyInfo().subscribe((user) => {
          if (user) {
            this.loggedUser = user;
            const userName = this.loggedUser.name;
            this.userName = userName?.split(' ');
            let unitCodes = `71|642|193|409|73|269|641|23|59|27|243|24|50|476|28|188|149|913|186`.split('|');
            //user.nickName?.split(':')[1].split('|');

            if (!unitCodes[0]) {
              // Pode ser que exista algum usuário sem unitCode, nesse caso exibe uma mensagem de informação
              return this.helpersService.showToast(
                DialogLayoutDisplay.INFO,
                this.resourceService.getResource('@direction.pages.menu.titleNotFoundUnitCode'),
                this.resourceService.getResource('@direction.pages.menu.messageNotFoundUnitCode'),
                undefined,
                undefined,
                undefined,
                ToastUserViewTypeEnum.STANDARD
              );
            }
            this.unitCodeSelected = unitCodes[0]; // Recebe o primeiro unitCode do usuário
            this.turnstileService.setUnitCode(unitCodes[0]); // Seta o primeiro unitCode do usuário no service
            this.unitCodes = unitCodes.sort();

            this.turnstileService.getTurnstilesByUnitCode(this.unitCodeSelected).subscribe((turnstiles) => {
              this.turnstileService.setTurnstileId(turnstiles.value[0].manufacturerId);
            });
          }
        });
      }
    });

    this.updateMenuFavorite();

    this.menuService
      .getFavoriteApplication()
      .pipe()
      .subscribe((response: FavoriteMenu[]) => {
        this.menuFavorite = response;
      });
  }

  getSubUnitcodeSelected$(): Observable<any> {
    return this.subUnitcodeSelected$.asObservable();
  }

  setTitle(title: string): void {
    this.menuService.setApplicationTitle(title);
  }

  updateMenuFavorite(): void {
    this.menuService.getMenuFavorite().subscribe((itemsMenu) => {
      this.menuFavorite = itemsMenu;
    });
  }

  rebooTurnstilesManager(): void {
    this.confirmBoxEvokeService
      .warning(
        this.resourceService.getResource('@direction.pages.menu.reboot.titleConfirm'),
        this.resourceService.getResource('@direction.pages.menu.reboot.rebootMessage'),
        this.resourceService.getResource('@direction.pages.menu.reboot.yes'),
        this.resourceService.getResource('@direction.pages.menu.reboot.no')
      )
      .subscribe((resp) => {
        if (resp.success) this.turnstileService.rebooTurnstilesManager();
      });
  }

  isLogged(): boolean {
    return this.helpersService.getDsAuthJWTToken().isValid();
  }

  getShowSideBarSearch() {
    return this.menuService.getShowSearchMenu();
  }

  showModalUnlockAccess() {
    this.modalService
      .showModalUnlockAccess(
        this.unitCodeSelected,
        this.resourceService.getResource('@direction.pages.popupCredential.title'),
        false
      )
      .subscribe((result: any) => {
        if (result) {
          result.unitCode = this.unitCodeSelected;
          this.turnstileService.sendReleaseEntrance(result);
        }
      });
  }

  getTitleUnitCodeButton(unitCode: string) {
    return UnitCode[unitCode];
  }

  setUnitCode(unitCode: string) {
    this.turnstileService.setUnitCode(unitCode);
    this.unitCodeSelected = unitCode;
  }

  navigateTo(url: string, title?: string) {
    this.setTitle(title);
    if (url.includes('grid/')) {
      this.helpersService.reloadTo(this.router, url, null);
    }
  }

  /* navigateTo(url: string, title?: string) {
    this.helpersService.reloadTo(this.router, url, null);
    this.setTitle(title);
  } */
}
